export enum QueryParams {
    userIndex = "user_index",
    cartCode = "cart_code",
    storeNumber = "store_number",
    referringUrl = "referringURL",
    forceChat = "forceChat",
    tenantRoute = "tenantRoute",
    actionId = "actionId",
}
